import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Alert,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

interface CarteArriveeChineComponentProps {
  carteArrivee: string;
  setCarteArrivee: React.Dispatch<React.SetStateAction<string>>;
  reuseBilletHotel: boolean;
  billetAvionECard: File | null;
  setBilletAvionECard: React.Dispatch<React.SetStateAction<File | null>>;
  pasDeBilletECard: boolean;
  setPasDeBilletECard: React.Dispatch<React.SetStateAction<boolean>>;
  hotelECard: File | null;
  setHotelECard: React.Dispatch<React.SetStateAction<File | null>>;
  pasDeHotelECard: boolean;
  setPasDeHotelECard: React.Dispatch<React.SetStateAction<boolean>>;
}

const CarteArriveeChineComponent: React.FC<CarteArriveeChineComponentProps> = ({
  carteArrivee,
  setCarteArrivee,
  reuseBilletHotel,
  billetAvionECard,
  setBilletAvionECard,
  pasDeBilletECard,
  setPasDeBilletECard,
  hotelECard,
  setHotelECard,
  pasDeHotelECard,
  setPasDeHotelECard,
}) => {
  const { t } = useTranslation('formulaires');

  return (
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 2,
        mb: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
        {t('carteArriveeChine.title')}
      </Typography>

      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        {t('carteArriveeChine.description')}
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="carte-arrivee-label">
          {t('carteArriveeChine.question')}
        </InputLabel>
        <Select
          labelId="carte-arrivee-label"
          value={carteArrivee}
          label={t('carteArriveeChine.question')}
          onChange={(e) => setCarteArrivee(e.target.value)}
        >
          <MenuItem value="oui">{t('carteArriveeChine.yesWithPrice')}</MenuItem>
          <MenuItem value="non">
            {t('carteArriveeChine.noWithDetails')}
          </MenuItem>
        </Select>
      </FormControl>

      {carteArrivee === 'non' && (
        <Alert severity="warning" sx={{ mb: 1 }}>
          <Typography variant="h6">
            {t('carteArriveeChine.warning')}
          </Typography>
        </Alert>
      )}

      {carteArrivee === 'oui' && !reuseBilletHotel && (
        <>
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {t('carteArriveeChine.uploadTicket')}
            </Typography>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              disabled={pasDeBilletECard}
              onChange={(e) => setBilletAvionECard(e.target.files?.[0] || null)}
            />
            {billetAvionECard && !pasDeBilletECard && (
              <Typography variant="caption" sx={{ ml: 1, color: 'green' }}>
                ✓ {billetAvionECard.name}
              </Typography>
            )}
            <FormControlLabel
              sx={{ display: 'block', mt: 1 }}
              control={
                <Checkbox
                  checked={pasDeBilletECard}
                  onChange={(e) => {
                    setPasDeBilletECard(e.target.checked);
                    if (e.target.checked) setBilletAvionECard(null);
                  }}
                />
              }
              label={t('carteArriveeChine.noTicketCheckbox')}
            />
          </Box>

          <Box sx={{ mb: 1 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {t('carteArriveeChine.uploadHotel')}
            </Typography>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              disabled={pasDeHotelECard}
              onChange={(e) => setHotelECard(e.target.files?.[0] || null)}
            />
            {hotelECard && !pasDeHotelECard && (
              <Typography variant="caption" sx={{ ml: 1, color: 'green' }}>
                ✓ {hotelECard.name}
              </Typography>
            )}
            <FormControlLabel
              sx={{ display: 'block', mt: 1 }}
              control={
                <Checkbox
                  checked={pasDeHotelECard}
                  onChange={(e) => {
                    setPasDeHotelECard(e.target.checked);
                    if (e.target.checked) setHotelECard(null);
                  }}
                />
              }
              label={t('carteArriveeChine.noHotelCheckbox')}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default CarteArriveeChineComponent;
